import { gql } from '@apollo/client';

const GET_CONTACT_US = gql`
  query ContactUsPage {
    header {
      headerButtons {
        id
        label
        variant
      }
      navigationLinks {
        id
        title
        url
      }
      headerLogo {
        id
        label
        url
        image {
          url
        }
      }
    }

    contactUsPage {
      dynamic {
        ... on ComponentHeroContactUsHeroContactUs {
          backgroundImage {
            url
            name
          }
          socialLink {
            icon {
              url
              name
            }
            url
            isExternal
          }
          subTitle
          title
        }
        ... on ComponentContactUsConnectExperts {
          button {
            label
          }
          subTitle
          title
          backgroundImage {
            url
            name
          }
          contactModes {
            description
            label
            icon {
              url
              name
            }
          }
        }
        ... on ComponentContactUsScheduleSection {
          id
          title
          subTitle
          bookButton {
            id
            label
            variant
          }
          enquireButton {
            id
            label
            variant
          }
        }
        ... on ComponentContactUsContactInfo {
          id
          title
          subTitle
          contactBox {
            id
            contactType
            contactSource
            timing
          }
        }
        ... on ComponentContactUsLocationSliderList {
          locationSliderList {
            backgroundImage {
              url
              name
            }
            location
          }
        }
      }
    }

    footer {
      navigationBox {
        links {
          id
          label
          url
          isExternal
        }
        title
      }
      contactInfoBox {
        infoDetailsList {
          id
          label
          icon {
            url
            name
          }
        }
        title
      }
      socialLinkBox {
        iconLinkList {
          icon {
            url
          }
          isExternal
          url
        }
      }
      downloadLinks {
        id
        url
        linkImage {
          width
          name
          url
        }
      }
      footerBottom {
        privacyLinks {
          id
          label
          url
          isExternal
        }
        copyRights
      }
      privacyPolicyContent
      termsConditionContent
    }
  }
`;
export default GET_CONTACT_US;
